// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"4837f584","126":"208caecb","153":"d55fd305","156":"7f58d938","194":"941db614","282":"cd696319","356":"cf623494","453":"fe9688b2","541":"f0c34df2","564":"d42a46aa","637":"97fcb57b","748":"90f71910","839":"61069f9a"}[chunkId] + ".chunk.js";
};